
const getStaffclients = () => {
    const staffClients = localStorage.getItem("staffClients")
        ? JSON.parse(localStorage.getItem("staffClients"))
        : null;
    return staffClients;
};

const InitialState = {
    staffClients: getStaffclients(),
};

const StaffClientReducer = (state = InitialState, action) => {

    if (action.type === "Save_Staff_Clients") {
        const newState = {
            staffClients: action.payload,
        };

        localStorage.setItem("staffClients", JSON.stringify(action.payload));
        return newState;
    }

    //logout
    else if (action.type === "Remove_User") {
        localStorage.removeItem("staffClients");
        const newState = {
            staffClients: null
        };
        return newState;
    }

    return state;
};

export default StaffClientReducer;
